import axios from "axios";
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL + '/service-bookings',
  timeout: 120000,
  withCredentials: true,
});

export const createBooking = async (bookingData) => {
  try {
    const response = await api.post("/", bookingData);
    return { success: true, data: response.data };
  } catch (error) {
    console.error("Booking creation error:", error.response?.data);
    return {
      success: false,
      timedOut: !!error.response?.data?.timedOut,
      error: error.response?.data?.message || "Failed to create booking",
      validationErrors: error.response?.data?.errors,
      status: error.response?.status,
      data: error.response?.data
    };
  }
};

export const getClientBookings = async () => {
  const token = localStorage.getItem("user_token");
  try {
    const response = await api.get("/client", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { success: true, data: response.data.data || response.data.bookings || [] };
  } catch (error) {
    console.error("Client bookings fetch error:", error.response?.data?.message || error.message);
    return { success: false, error: error.response?.data?.message || "Failed to fetch client bookings" };
  }
};